export default "__VITE_ASSET__DgmH$PgB__"